<template>
    <div :width="1200">
        <Loading :isLoading="saveLoading" :text="LoadingText" />
        <Spin v-if="innerSpin" size="large" fix></Spin>
        <div style="height:500px;overflow:scroll;padding-left:20px;padding-right:20px;">
            <Form ref="productForm" :model="productForm" :rules="ruleValidate" label-position="top" class="small-form">
                <div class="productInfoWrap">
                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="大类" prop="productMainCategoryUuid"
                            v-if="isShowByProp('productMainCategoryUuid')">
                            <Select v-model="productForm.productMainCategoryUuid" transfer>
                                <Option v-for="item in popupEditResource.mainCategorySource"
                                    :key="item.mainCategoryUuid" :value="item.mainCategoryUuid">
                                    {{ item.mainCategoryName }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="小类" prop="productSubCategoryUuid"
                            v-if="isShowByProp('productSubCategoryUuid')">
                            <Select v-model="productForm.productSubCategoryUuid" filterable transfer>
                                <Option v-for="item in subCategorySource" :key="item.subCategoryUuid"
                                    :value="item.subCategoryUuid">{{ item.subCategoryName }} {{ item.brand }}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="产品形态" prop="productForm"   v-if="isShowByProp('productForm')">
                            <Select v-model="productForm.productForm" transfer>
                                <Option v-for="ft in formOptions" :key="ft" :value="ft">{{ ft }}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <!-- <FormItem label="品牌" prop="productBrandUuid">
							<Select v-model="productForm.productBrandUuid" disabled filterable transfer>
								<Option v-for="item in popupEditResource.brandSource" :key="item.brandUuid"
									:value="item.brandUuid">{{ item.brandName }}</Option>
							</Select>
						</FormItem> -->
                        </Col>
                        <Col span="4">
                        <FormItem label="颜色" prop="productColor"  v-if="isShowByProp('productColor')">
                            <Input v-model="productForm.productColor"></Input>
                        </FormItem>
                        </Col>

                    </Row>
                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem prop="productPackageUuid" v-if="isShowByProp('productPackageUuid')">
                            <span slot="label">纸箱</span>
                            <Select v-model="productForm.productPackageUuid" filterable transfer>
                                <Option v-for="item in popupEditResource.packageSource" :key="item.packageUuid"
                                    :value="item.packageUuid">{{ item.packageName + ' ' + item.packageRemark }}</Option>
                            </Select>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="装箱量" prop="productPackageQuantity" v-if="isShowByProp('productPackageQuantity')">
                            <integer-input :min="1" :max="1000000" v-model="productForm.productPackageQuantity" />
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="单位" prop="productUnitUuid" v-if="isShowByProp('productUnitUuid')">
                            <Select v-model="productForm.productUnitUuid" filterable transfer>
                                <Option v-for="item in popupEditResource.unitSource" :key="item.unitUuid"
                                    :value="item.unitUuid">{{ item.unitName }}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="规格" v-if="isShowByProp('productSpec')">
                            <Input v-model="productForm.productSpec"></Input>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="包装费(箱/元)" prop="packingFee" v-if="isShowByProp('packingFee')">
                            <Input v-model="productForm.packingFee"></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="配送费(箱/元)" prop="deliveryFee"  v-if="isShowByProp('deliveryFee')">
                            <Input v-model="productForm.deliveryFee"></Input>
                        </FormItem>
                        </Col>
                    </Row>

                    <!-- 新增包装费、配送费 -->
                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="最小单位指标" prop="productIncreaseStepAmount" v-if="isShowByProp('productIncreaseStepAmount')">
                            <decimal-input v-model="productForm.productIncreaseStepAmount" :precision="0" />
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="最低起订量" prop="productMinOrderAmount"  v-if="isShowByProp('productMinOrderAmount')">
                            <decimal-input v-model="productForm.productMinOrderAmount" :precision="0" />
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="定金比例(%)" prop="productPreSaleDepositRatio" v-if="isShowByProp('productPreSaleDepositRatio')">
                            <integer-input v-model="productForm.productPreSaleDepositRatio" :min="0" :max="100" />
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="系列" prop="productSerialUuid" v-if="isShowByProp('productSerialUuid')">
                            <Select v-model="productForm.productSerialUuid" filterable transfer>
                                <Option v-for="item in popupEditResource.serialSource" :key="item.serialUuid"
                                    :value="item.serialUuid">{{ item.serialName }} {{ item.brand }}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="苗高(cm)" prop="seedlingHeight" v-if="isShowByProp('seedlingHeight')">
                            <Input v-model="productForm.seedlingHeight"></Input>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="对叶数" prop="leavesNumber" v-if="isShowByProp('leavesNumber')">
                            <Input v-model="productForm.leavesNumber"></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="盘数(如100穴/盘)" prop="pottingSeedling" v-if="isShowByProp('pottingSeedling')">
                            <integer-input v-model="productForm.pottingSeedling" :min="0" class="width50" />
                            <Select v-model="productForm.pottingSeedlingUnit" filterable transfer class="width50">
                                <Option v-for="item in pottingSeedlingUnit" :key="item" :value="item">{{ item }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16" v-if="isShowByProp('productFinishImageFile')||isShowByProp('productSeedImageFile')||isShowByProp('productTraySeedImageFile')||isShowByProp('productPackImageFile')||isShowByProp('productStandardImageFile')">
                        <Col span="16">
                        <div style="font-size: 12px;color:red;padding:5px 0px;">
                            温馨提示：为确保客户端图片显示效果良好,请上传宽高比为1:1.1的图片（如宽750px-高825px）
                        </div>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="成品图" prop="productFinishImageFile"  v-if="isShowByProp('productFinishImageFile')">
                            <div class="img-card">
                                <single-file-upload-with-name v-model="productForm.productFinishImageFile"  :dataPath="dataPath"
                                    :imgHeight="150" :imgWidth="150" ref="productFinishImageFileImg" />
                                <Icon style="margin-top: -30px;" type="ios-eye" class="icon-delete"
                                    @click="showImageModal('productFinishImageFileImg')"
                                    v-if="productForm.productFinishImageFile != '' && productForm.productFinishImageFile != null" />
                                <Icon type="md-trash" class="icon-delete" @click="deleteFinishImageFile()"
                                    v-if="productForm.productFinishImageFile != '' && productForm.productFinishImageFile != null" />
                            </div>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="种苗图" v-if="isShowByProp('productSeedImageFile')">
                            <div class="img-card"  >
                                <single-file-upload-with-name v-model="productForm.productSeedImageFile" :dataPath="dataPath"
                                    :imgHeight="150" :imgWidth="150" ref="productSeedImageFile" />
                                <Icon style="margin-top: -30px;" type="ios-eye" class="icon-delete"
                                    @click="showImageModal('productSeedImageFile')"
                                    v-if="productForm.productSeedImageFile != '' && productForm.productSeedImageFile != null" />
                                <Icon type="md-trash" class="icon-delete" @click="deleteSeedImageFile()"
                                    v-if="productForm.productSeedImageFile != '' && productForm.productSeedImageFile != null" />
                            </div>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="盘苗图"  v-if="isShowByProp('productTraySeedImageFile')">
                            <div class="img-card">
                                <single-file-upload-with-name v-model="productForm.productTraySeedImageFile"   :dataPath="dataPath"
                                    :imgHeight="150" :imgWidth="150" ref="productTraySeedImageFile" />
                                <Icon style="margin-top: -30px;" type="ios-eye" class="icon-delete"
                                    @click="showImageModal('productTraySeedImageFile')"
                                    v-if="productForm.productTraySeedImageFile != '' && productForm.productTraySeedImageFile != null" />
                                <Icon type="md-trash" class="icon-delete" @click="deleteTraySeedImageFile()"
                                    v-if="productForm.productTraySeedImageFile != '' && productForm.productTraySeedImageFile != null" />
                            </div>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="包装图"  v-if="isShowByProp('productPackImageFile')">
                            <div class="img-card">
                                <single-file-upload-with-name v-model="productForm.productPackImageFile"   :dataPath="dataPath"
                                    :imgHeight="150" :imgWidth="150" ref="productPackImageFile" />
                                <Icon style="margin-top: -30px;" type="ios-eye" class="icon-delete"
                                    @click="showImageModal('productPackImageFile')"
                                    v-if="productForm.productPackImageFile != '' && productForm.productPackImageFile != null" />
                                <Icon type="md-trash" class="icon-delete" @click="deletePackImageFile()"
                                    v-if="productForm.productPackImageFile != '' && productForm.productPackImageFile != null" />
                            </div>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="标准卡图"  v-if="isShowByProp('productStandardImageFile')">
                            <div class="img-card">
                                <single-file-upload-with-name v-model="productForm.productStandardImageFile"    :dataPath="dataPath"
                                    :imgHeight="150" :imgWidth="150" ref="productStandardImageFile" />
                                <Icon style="margin-top: -30px;" type="ios-eye" class="icon-delete"
                                    @click="showImageModal('productStandardImageFile')"
                                    v-if="productForm.productStandardImageFile != '' && productForm.productStandardImageFile != null" />
                                <Icon type="md-trash" class="icon-delete" @click="deleteStandardImageFile()"
                                    v-if="productForm.productStandardImageFile != '' && productForm.productStandardImageFile != null" />
                            </div>
                        </FormItem>
                        </Col>

                    </Row>
                    <Row>
                        <Col span="24">
                        <FormItem label="示范视频"  v-if="isShowByProp('demonstrationVideo')">
                            <template>
                                <Upload action="https://up-z2.qiniup.com/" :data="uploadParams" :format="['mp4']"
                                    accept=".mp4" :on-format-error="handleFormatError"
                                    :on-success="handleUploadVideoSuccess" :before-upload="beforeVideoUpload"
                                    :show-upload-list="showUploadList"
                                    v-if="readonly == false && demonVideos.length < 5">
                                    <Button icon="ios-cloud-upload-outline">上传视频</Button>
                                </Upload>

                                <Row :gutter="16" style="margin-top: 10px;">
                                    <Col span="5" v-for="(item, index) in demonVideos" :key="index">
                                    <div class="img-card">
                                        <video width="150" height="150" controls>
                                            <source :src="item.src" type="video/mp4">
                                        </video>
                                        <Icon type="md-trash" class="icon-delete" @click="deleteVideo(index)"
                                            v-if="readonly == false" />
                                    </div>
                                    </Col>
                                </Row>
                            </template>
                        </FormItem>
                        </Col>


                    </Row>
                </div>

                <Divider orientation="left" size="small" v-if="isShowByProp('productFeatureContract')">个性合同</Divider>
                <div>
                    <Row :gutter="16">
                        <Col span="24"  v-if="isShowByProp('productFeatureContract')">
                        <Input v-model="productForm.productFeatureContract" :rows="5" type="textarea"  > </Input>
                        </Col>
                    </Row>
                </div>
                <div>  <Input style="visibility: hidden;" :value="productForm.productUuid"></Input></div>
            </Form>
        </div>
      
    </div>
</template>

<script>
import {
    PRODUCT_APPROVAL_INREVIEW,
    PRODUCT_APPROVAL_NO,
    PRODUCT_APPROVAL_YES
} from '@/view/product-management/product-management/ProductApproveDefine';
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from '@/view/mixins/form-edit-mode';

//   import ModalVisible from '@/view/mixins/modal-visible';
import IntegerInput from '@/components/number-input/integer-input';
import DecimalInput from '@/components/number-input/decimal-input';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';
import ImageCut from '@/components/image-cut/ImageCut';
import {
    getImageSrc
} from '@/libs/tableRowImageRender';

import {
    getProductDetail,
    saveProduct,
    saveProductList,

    qiniuToken
} from '@/api/modules/product-management/product-management';
import {
    saveProductApprove
} from '@/api/modules/product-management/productApprove-management';
import { TabPane } from 'iview';
import Loading from '@/components/loading/Loading.vue';
import { UPLOAD_FILE_API, FILE_SERVER } from '@/api/modules/files';

export default {
    name: 'ProductPopupEdit1',
    components: {
        IntegerInput,
        SingleFileUploadWithName,
        DecimalInput,
        ImageCut,
        Loading
    },
    //  mixins: [ModalVisible],

    props: {
        popupEditResource: {
            type: Object,
            required: true,
            default() {
                return {
                    seedFarmCode: '',
                    mainCategorySource: [],
                    rawSubCategorySource: [],
                    brandSource: [],
                    serialSource: [],
                    unitSource: [],
                    packageSource: [],
                    masterSource: [],
                    allRegionInfo: [],
                    approvalSource: [],
                    packingFee: '',
                    deliveryFee: '',
                    // productCategoryFeature: '',
                    productCultivation: 0,
                    demonstrationVideo2: 0,
                    demonstrationVideo3: 0,
                    demonstrationVideo4: 0,
                    demonstrationVideo5: 0,
                    discountPolicy: 0,
                    productPreSaleDiscountRatio: 0,
                    productFeatureContract: '',
                    pottingSeedling: 0,
                    seedlingHeight: '',
                    leavesNumber: ''
                };
            }
        },
        dataPath:{
            type: Object,
            required:true,
            default: function (){
                return { updatePath:'' };
            }
        },
        formEditMode: {
            type: String,
            default: FORM_EDIT_MODE_MODIFY
        },
        readonly: {
            type: Boolean,
            default: false
        },
        showPropList:{
            type:Array,
            default:function (){
                return [];
            }
        }
    },

    data() {
        const productInitForm = this.getProductInit();

        return {
   
            saveLoading: false,
            LoadingText: "Loading",
            imageDomain: this.imageDomain,
            demonVideos: [],
            showUploadList: false,
            uploadParams: {},
            innerSpin: false,
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            // formEditMode: FORM_EDIT_MODE_CREATE,
            formOptions: ['种苗', '种条', '种球', '种子', '组培苗', '半成品', '其他'],
            stationOptions: ['广州站', '岭南站', '北京站', '深圳站', '其他'],
            productTagsList: [{
                value: 'distributionStationName',
                label: '站点'
            }, {
                value: 'productCode',
                label: '编码'
            }, {
                value: 'productName',
                label: '名称'
            }, {
                value: 'productPackageQuantity',
                label: '装箱量'
            },
            {
                value: 'productUnitUuid',
                label: '单位'
            },
            {
                value: 'productPackageUuid',
                label: '纸箱'
            },
            {
                value: 'productSpec',
                label: '规格'
            }
            ],
            productForm: productInitForm,
            ruleValidate: {
                productMainCategoryUuid: [{
                    required: true,
                    message: '大类不能为空',
                    trigger: 'blur'
                }],
                productSubCategoryUuid: [{
                    required: true,
                    message: '小类不能为空',
                    trigger: 'blur'
                }],
                productName: [{
                    required: true,
                    message: '名称不能为空',
                    trigger: 'blur'
                }],
                productUnitUuid: [{
                    required: true,
                    message: '单位不能为空',
                    trigger: 'blur'
                }],
                productForm: [{
                    required: true,
                    message: ' ',
                    trigger: 'blur'
                }],
                productPackageUuid: [{
                    required: true,
                    message: ' ',
                    trigger: 'blur'
                }],
                productPackageQuantity: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '装箱量不能为空',
                    trigger: 'blur'
                }],
                packingFee: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '包装费不能为空',
                    trigger: 'blur'
                }],
                deliveryFee: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '配送费不能为空',
                    trigger: 'blur'
                }],
                productFinishImageFile: [{
                    required: true,
                    message: '成品图不能为空',
                    trigger: 'blur'
                }],
                productIncreaseStepAmount: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '最小单位指标不能为空',
                    trigger: 'blur'
                }],
                productMinOrderAmount: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '最小起订量不能为空',
                    trigger: 'blur'
                }],
                seedlingHeight: [{
                    required: true,
                    message: '苗高不能为空',
                    trigger: 'blur'
                }],
                leavesNumber: [{
                    required: true,
                    message: '对叶数不能为空',
                    trigger: 'blur'
                }],
                pottingSeedling: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '盘数不能为空',
                    trigger: 'blur'
                }],
                productPreSaleDepositRatio: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '定金比例不能为空 ',
                    trigger: 'blur'
                }],
                // productCategoryFeature: [{
                // 	required: true,
                // 	message: '常见问题不能为空',
                // 	trigger: 'blur'
                // }],
                productCultivation: [{
                    required: true,
                    message: '栽培技术不能为空',
                    trigger: 'blur'
                }],
                //demonstrationVideo: [{ required: true, message: '示范视频不能为空', trigger: 'blur' }],
                //discountPolicy: [{ required: true, message: '优惠政策不能为空', trigger: 'blur' }],
                productColor: [{
                    required: true,
                    message: '颜色不能为空',
                    trigger: 'blur'
                }],
                productSerialUuid: [{
                    required: true,
                    message: ' ',
                    trigger: 'blur'
                }]
            },
            subCategoryRelateMaster: {
                name: ''
            },
            subCategorySource: [],
            commissionForm: {
                provinceUuid: '',
                cityUuid: '',
                distUuid: '',
                commission: 0,
                commissionType: '预售'
            },
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            pottingSeedlingUnit: ['盘', '袋', '盒', '筐', '箱']
        };
    },

    mounted(){
      
    },
    computed: {
        productIsApproval() {
            return this.productForm.productApproval === PRODUCT_APPROVAL_INREVIEW
                || this.productForm.productApproval === PRODUCT_APPROVAL_YES;
        }
    },
    watch: {
        'productForm.productMainCategoryUuid': {
            deep: true,
            immediate: true,
            handler: function (newVal) {
                this.subCategorySource = [];
                if (newVal !== '') {
                    this.subCategorySource = this.popupEditResource.rawSubCategorySource.filter(item => item
                        .subCategoryMainUuid === newVal);
                }

                if (this.productForm.productSubCategoryUuid !== '') {
                    const find = this.subCategorySource.find(item => item.subCategoryUuid === this.productForm
                        .productSubCategoryUuid);
                    if (!find) {
                        this.productForm.productSubCategoryUuid = '';
                        this.subCategoryRelateMaster.name = '';
                        this.subCategoryRelateMaster.phone = '';
                    }
                }
            }
        },
        'productForm.productSubCategoryUuid': {
            deep: true,
            immediate: true,
            handler: function (newVal) {

                this.productForm.productRelateMasterLoginUuid = '';
                if (newVal !== '') {
                    const subCategory = this.popupEditResource.rawSubCategorySource.find(item => item
                        .subCategoryUuid === newVal);
                    if (subCategory) {
                        this.productForm.productRelateMasterLoginUuid = subCategory
                            .subCategoryRelateMasterLoginUuid;

                        this.subCategoryRelateMaster.name = '';
                        this.subCategoryRelateMaster.phone = '';

                        const findMaster = this.popupEditResource.masterSource.find(m => m.userMasterLoginUuid
                            === subCategory.subCategoryRelateMasterLoginUuid);
                        if (findMaster) {
                            this.subCategoryRelateMaster.name = findMaster.userMasterName;
                            this.subCategoryRelateMaster.phone = findMaster.userMasterPhone;
                        }
                    }
                }
            }
        }
    },
    methods: {
        isShowByProp(propName) {
            return this.showPropList.includes(propName);
        },
        showImageModal(refName) {
            let imgPath = this.$refs[refName].imgPath;
            this.$Modal.info({
                title: '图片信息',
                render: h => {
                    return h("img", {
                        attrs: {
                            src: imgPath,
                            style: "width: 370px;height: 370px;"
                        }
                    });
                }
            });
        },
        deleteFinishImageFile() {
            this.$Modal.confirm({
                title: '确认',
                content: '是否删除成品图？',
                onOk: () => {
                    this.productForm.productFinishImageFile = '';
                }
            });
        },
        deleteSeedImageFile() {
            this.$Modal.confirm({
                title: '确认',
                content: '是否删除种苗图？',
                onOk: () => {
                    this.productForm.productSeedImageFile = '';
                }
            });
        },
        deleteTraySeedImageFile() {
            this.$Modal.confirm({
                title: '确认',
                content: '是否删除盘苗图？',
                onOk: () => {
                    this.productForm.productTraySeedImageFile = '';
                }
            });
        },
        deletePackImageFile() {
            this.$Modal.confirm({
                title: '确认',
                content: '是否删除包装图？',
                onOk: () => {
                    this.productForm.productPackImageFile = '';
                }
            });
        },
        deleteStandardImageFile() {
            this.$Modal.confirm({
                title: '确认',
                content: '是否删除标准卡图？',
                onOk: () => {
                    this.productForm.productStandardImageFile = '';
                }
            });
        },
        handleFormatError(request, file) {
            this.saveLoading = false;
            this.$Notice.warning({
                title: '格式错误',
                desc: '请上传mp4格式文件'
            });
        },
        async beforeVideoUpload(request) {
            // **注意这里的参数必须通过属性赋值，如果直接修改整个uploadParams是无效的。**
            // 上传之前设置上传参数,
            let suffix = request.name.substring(request.name.lastIndexOf("."));
            let filename = Date.now() + Math.random().toString(36).slice(2) + suffix;

            this.saveLoading = true;
            this.LoadingText = "示范视频上传中";
            await qiniuToken({}).then(res => {
                this.uploadParams.token = res.data.token;
                // 七牛response hash key的值自定义，后面如果需要浏览或者下载都需要这个地址，如果key不定义，那么七牛生成的key === hash的值
                this.uploadParams.key = filename;
            });
        },
        handleUploadVideoSuccess(request, file, list) {
            this.saveLoading = false;
            let videoPath = this.imageDomain + file.response.key;
            this.demonVideos.push({ id: '', src: videoPath, size: file.size });
        },
        // 删除视频
        deleteVideo(index) {
            this.$Modal.confirm({
                title: '确认',
                content: '是否删除视频？',
                onOk: () => {
                    this.demonVideos.splice(index, 1);
                }
            });
        },
        validateNumber(rule, value, callback) {
            if (/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(value)) {
                callback();
            }
            else {
                return callback(new Error());
            }
        },
        getProductInit() {
            return {
                productUuid: '',
                productMainCategoryUuid: '',
                productSubCategoryUuid: '',
                productRelateMasterLoginUuid: '',

                productCode: '',
                productName: '',
                productAlias: '',
                productUnitUuid: '',
                productPackageUuid: '',
                productPackageQuantity: 1,
                productSpec: '',
                packingFee: 0,
                deliveryFee: 0,
                productFinishImageFile: '',
                productSeedImageFile: '',
                demonstrationVideo: '',
                demonstrationVideo2: '',
                demonstrationVideo3: '',
                demonstrationVideo4: '',
                demonstrationVideo5: '',
                //优惠政策
                discountPolicy: '',
                productTraySeedImageFile: '',
                productPackImageFile: '',
                productStandardImageFile: '',
                productCategoryFeature: '',
                //栽培技术
                productCultivation: '',
                //特别通告
                productOtherSpec: '',
                //品种特征
                productfeatures: '',
                //关于售后
                afterService: '',
                productApproval: PRODUCT_APPROVAL_NO,
                productMinOrderAmount: 0,
                productIncreaseStepAmount: 0,
                productPreSaleDepositRatio: 20,
                productCurSaleDepositRatio: 20,
                productColor: '',
                productLeadTime: 60,
                productForm: '',
                productFontImageIndex: 1,
                productPreSaleDiscountRatio: 0,
                distributionStationName: '',
                productTags: '',
                productSerialUuid: '',
                seedlingHeight: 0,
                leavesNumber: 0,
                pottingSeedling: 0,
                //常见问题
                productCommonProblem: ''
            };
        },
        onVisibleChange(productUuid) {
            this.$refs.productForm.resetFields();
            this.productForm = this.getProductInit();
            this.demonVideos = [];
            if (!productUuid) {

            }
            else {

                getProductDetail(productUuid).then(res => {
                    const info = res.data.product;
                    const commissions = res.data.commissions;
                    this.productApproveDetail = res.data.productApproveDetail;

                    this.productForm = Object.assign(this.productForm, info);
                    if (this.productForm.demonstrationVideo) {
                        let videosArr = this.productForm.demonstrationVideo.split(',');
                        videosArr.forEach(item => {
                            this.demonVideos.push({ id: '', src: this.imageDomain + item, size: 0 });
                        });
                    }

                    this.productForm.productMainCategoryUuid = info.productMainCategoryUuid;
                    this.productForm.productSubCategoryUuid = info.productSubCategoryUuid;

                    this.provinceOptions = this.popupEditResource.allRegionInfo.filter(r => r.regionType
                        === 1);

          
                });
            }
        },
        onShowImage(image) {
            const imageSrc = getImageSrc(image);
            if (imageSrc) {
                window.open(imageSrc);
            }
        },
        onProvinceChange(provinceUuid) {
            this.commissionForm.distUuid = '';
            this.distOptions = [];

            this.commissionForm.cityUuid = '';
            this.cityOptions = this.popupEditResource.allRegionInfo.filter(r => r.regionType === 2 && r
                .regionParentUuid === provinceUuid);
        },
        onCityChange(cityUuid) {
            this.commissionForm.distUuid = '';
            this.distOptions = this.popupEditResource.allRegionInfo.filter(r => r.regionType === 3 && r
                .regionParentUuid === cityUuid);
        },
        // onCancel() {
        // 	this.modalVisible = false;
        // },

        sumbit(productUuids){


            // this.$refs.productForm.validate(valid => {
            // if (!valid) {
            //     this.$Message.error('请将打*号的内容填写完整!');
            //     return;
            // }

            // if (this.productForm.productMinOrderAmount < this.productForm.productIncreaseStepAmount) {
            //     this.$Message.error('最低起订量不能小于最小单位指标!');
            //     return;
            // }

            // if (Number(this.productForm.productMinOrderAmount) % Number(this.productForm.productIncreaseStepAmount) != 0) {
            //     this.$Message.error('最低起订量必须是最小单位指标的整数倍！');
            //     return;
            // }
            
            if(this.showPropList.includes('demonstrationVideo')){
                this.productForm.demonstrationVideo = '';
                if (this.demonVideos.length == 0) {
                    this.productForm.demonstrationVideo = '';
                }
                else {
                    this.demonVideos.forEach(item => {
                        if (this.productForm.demonstrationVideo == '') {
                            this.productForm.demonstrationVideo += item.src.replaceAll(this.imageDomain, '');
                        }
                        else {
                            this.productForm.demonstrationVideo += ',' + item.src.replaceAll(this.imageDomain, '');
                        }
                    });
                }
            }
          

            let productInfo={};  
            this.showPropList.forEach(item=>{              
                productInfo[item]=this.productForm[item];
            });
            let data={};
            data.productBasicInformationStr=JSON.stringify(productInfo);

            data.productUuidList=productUuids;

            this.saveLoading = true;
            this.LoadingText = "保存产品基本信息中";

            saveProductList(data).then(res=>{
                if(res.code==0){

                    this.saveLoading = false;
                    this.$Message.info("批量修改成功");
                    this.$emit('on-popup-submit-finish', this.formEditMode);
                }
               
            });

        // });
    
        },
        onSubmit() {
            this.$refs.productForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('请将打*号的内容填写完整!');
                    return;
                }

                if (this.productForm.productMinOrderAmount < this.productForm.productIncreaseStepAmount) {
                    this.$Message.error('最低起订量不能小于最小单位指标!');
                    return;
                }

                if (Number(this.productForm.productMinOrderAmount) % Number(this.productForm.productIncreaseStepAmount) != 0) {
                    this.$Message.error('最低起订量必须是最小单位指标的整数倍！');
                    return;
                }
                this.productForm.demonstrationVideo = '';
                if (this.demonVideos.length == 0) {
                    this.productForm.demonstrationVideo = '';
                }
                else {
                    this.demonVideos.forEach(item => {
                        if (this.productForm.demonstrationVideo == '') {
                            this.productForm.demonstrationVideo += item.src.replaceAll(this.imageDomain, '');
                        }
                        else {
                            this.productForm.demonstrationVideo += ',' + item.src.replaceAll(this.imageDomain, '');
                        }
                    });
                }
                console.log(this.productForm);
                const data = Object.assign({
                    formEditMode: this.formEditMode
                }, this.productForm);

                this.innerSpin = true;

                this.saveLoading = true;
                this.LoadingText = "保存产品基本信息中";
                saveProduct(data).then(res => {
                    this.innerSpin = false;
                    this.saveLoading = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            content: '',
                            onOk: () => {
                                // this.modalVisible = false;
                                if (this.formEditMode == FORM_EDIT_MODE_CREATE) {
                                    this.$emit('on-popup-submit-finish', this.formEditMode, res.data.product.productUuid, res.data.product.productCode);
                                }
                                else {
                                    this.$emit('on-popup-submit-finish', this.formEditMode, null, null);
                                }

                            }
                        });
                    }
                }).catch(() => {
                    this.innerSpin = false;
                    this.saveLoading = false;
                });
            });
        }
    }
};
</script>

<style lang="less">
.productInfoWrap .number-input .ivu-input-number-input {
    text-align: left !important;
}

.width50 {
    width: 50px;
}

.icon-delete {
    font-size: 30px;
    position: absolute;
    top: 30px;
    right: 2px;
    background-color: rgba(255, 255, 255, 0.6);
    border-radius: 50%;
}

.img-card {
    position: relative;
    width: 150px;
    height: 150px;
    margin-top: 10px;
    overflow: hidden;
}
</style>
